<template>
  <div id="app">
    <b-overlay
      id="authenticating-overlay"
      no-wrap
      :show="authenticating"
      variant="light"
      opacity="0.5"
      rounded="false"
    />
    <Header />
    <!-- use fullPath as key to refresh page on param change -->
    <!-- substring to NOT refresh on locale change -->
    <router-view
      v-if="!authenticating"
      :key="$route.fullPath.substring(3)"
    />
    <div
      v-else
      class="page"
    />
    <confirmation-modal />
    <progress-modal />
    <Footer />
  </div>
</template>

<script>
import ConfirmationModal from '@/common/components/modals/ConfirmationModal.vue';
import Header from '@/common/components/layout/Header.vue';
import Footer from '@/common/components/layout/Footer.vue';
import ProgressModal from '@/common/components/modals/ProgressModal.vue';

import { mapState, mapMutations, mapActions } from 'vuex';

export default {

  components : {
    ConfirmationModal,
    Header,
    Footer,
    ProgressModal
  },

  data() {
    return {
      authenticating: true
    };
  },

  computed: {
    ...mapState('login', [
      'isUserAuthenticated'
    ]),
  },

  async created() {
    this.CLOSE_MODALS();
    await this.GET_USER_AUTHENTICATION();
    await this.GET_USER_STATUSES();
    await this.GET_USERGROUP_STATUSES();
    await this.getAppStaticData();
    await this.CHECK_DATASTORE_AVAILABILITY();
    await this.CHECK_GEOSERVER_AVAILABILITY();
    this.authenticating = false;
  },

  mounted() {
    // Watch modal closing event
    this.$root.$on('bv::modal::hide', (e) => {
      this.CLOSE_MODAL(e.componentId.split('-')[0]);
    });
  },

  methods: {
    ...mapMutations('modal', [
      'CLOSE_MODAL',
      'CLOSE_MODALS'
    ]),
    ...mapActions('login', [
      'GET_USER_AUTHENTICATION'
    ]),
    ...mapActions('users', [
      'GET_USER_STATUSES'
    ]),
    ...mapActions('usergroups', [
      'GET_USERGROUP_STATUSES'
    ]),
    ...mapActions('resources', [
      'GET_RESOURCE_DATA_FORMATS'
    ]),
    ...mapActions('resources/datastore', [
      'CHECK_DATASTORE_AVAILABILITY'
    ]),
    ...mapActions('resources/geoserver', [
      'CHECK_GEOSERVER_AVAILABILITY'
    ]),

    async getAppStaticData() {
      await this.GET_RESOURCE_DATA_FORMATS();
    }
  }
};
</script>

<style>
#authenticating-overlay {
  z-index: 1103 !important;
  height: 100vh;
  width: 100vw;
}
</style>
